var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 10,
    viewBox: "0 0 35 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4961 5.35355C29.6914 5.15829 29.6914 4.84171 29.4961 4.64644L26.3142 1.46446C26.1189 1.2692 25.8023 1.2692 25.6071 1.46446C25.4118 1.65973 25.4118 1.97631 25.6071 2.17157L28.4355 5L25.6071 7.82843C25.4118 8.02369 25.4118 8.34027 25.6071 8.53553C25.8023 8.73079 26.1189 8.73079 26.3142 8.53553L29.4961 5.35355ZM5 5.5L29.1426 5.5L29.1426 4.5L5 4.5L5 5.5Z",
    fill: "#0D8ECA",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f043ddf2890dcc999b4a4302cd1adf0c.svg";
export { ForwardRef as ReactComponent };